import { TemplateConfig } from '../types';

export const longingSpreadConfig: TemplateConfig = {
  id: 'longing-spread',
  name: '思念牌阵',
  description: '分析对方是否在思念我，以及关系走向',
  cardCount: 6,
  
  fieldDefaults: {
    title: '思念牌阵',
    customerQuestion: '分析对方是否在思念我、对方对我的态度和感觉、我该做出什么行动以及未来关系的走向。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌'
    ],
    cardInfos: [
      '对方在想我吗',
      '对方在等我吗',
      '对方对我的态度',
      '对方现在对我的感觉',
      '我该怎么办',
      '关系的走向'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};